'use strict'
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';

let hrefColor = {"color":"black"};

export default class Home extends React.Component {

    constructor(props){
        super(props);
        this.generateMenuOptions = this.generateMenuOptions.bind(this);
    }

    componentWillMount() {
    }

    clickhandle(link) {
        window.location.href = link;
    }

    generateMenuOptions(options = null){
        let that = this;
        let object = (options !== null) ? options : this.props.menuOptions;
        let subMenu = [];
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                if (object[key]["children"] !== null && object[key]["children"] !== undefined) {
                    let menu = that.generateMenuOptions(object[key]["children"]);
                    subMenu = [ ...subMenu, ...menu ];
                }
                else {
                    object[key]['action'] = null;
                    subMenu.push(object[key]);
                }
            }
        }
        return subMenu;
    }


    render() {
        var that = this;

        let menuOptions = this.generateMenuOptions(this.props.menuOptions);


        let landingPage =menuOptions.map(function (innerData, index) {
            if(innerData["label"]!== "Home"){
                return (
                    <div className="col-sm-3" key={`div_${index}`}>
                        <div className=' d-flex card justify-content-center align-items-center ht-100 mg-b-10 pd-20' key={`page_${index}`} >
                            {/* <i data-feather={innerData["icon"]} className={innerData.img} onClick={that.clickhandle.bind(that, innerData.link)}></i> */}
                            {/* <span key={`link_${index}`} onClick={that.clickhandle.bind(that, innerData.link)} style={{ cursor: "pointer" }}>{innerData.label}</span> */}
                            <Link to={innerData["link"]} style={hrefColor}>
                                <span>{innerData["label"]}</span>
                            </Link>
                        </div>
                    </div>);

            }
        });
        return (
            <div id="main-content">
                <div className='box-no-padding mainCont'>
                    {/* <div className='col-md-12' style={{ marginBottom: '10px', borderBottom: "solid 1px #dddddd" }}>
                        <h4>
                            <a href="/home" tool-tip="Go Back">
                            </a>{"Admin Panel"}</h4>
                    </div> */}
                    <div className="row" style={{ marginBottom: "10px" }}>
                            {/* <DatasetFilter /> */}
                            {/* style={{ textAlign: "center" }} */}
                        {landingPage}
                    </div>
                </div>
            </div>
        );
    }
}

